import request from "./axios";


/**
 * 我的作业列表
 */
export function getMineWork(userId, orderBy, isAsc, timeRange, workStatus, workName, pageSize, pageNo) {
    return request({
        url: "/api/teaching/teachingWork/userWorkList",
        method: "get",
        params:{
            userId, orderBy, isAsc, timeRange, workStatus, workName, pageSize, pageNo
        }
    });
}

/**
 * 作品列表
 * @param {*} isCourseWork 
 * @param {*} workTag 
 * @param {*} scene 
 * @param {*} pageNo 
 * @param {*} pageSize 
 * @param {*} courseId 
 * @param {*} isShare 
 * @param {*} pageNo 
 * @param {*} pageSize 
 */
export function userWorkList(
    userId,
    isCourseWork,
    workTag,
    scene,
    courseId,
    isShare,
    orderBy,
    isAsc,
    pageNo,
    pageSize,
) {
    return request({
        url: "/api/teaching/teachingWork/userWorkList",
        method: "get",
        params: { userId, isCourseWork, workTag, courseId, isShare, scene, orderBy, isAsc, pageNo, pageSize }
    });
}


/**
 * 用户收藏的作品列表
 * @param {} userId 
 */
export function collectWorkList(userId) {
    return request({
        url: "/api/teaching/teachingWork/listCollectWork?userId=" + userId + "&pageSize=" + 999,
        method: "get"
    })
}

export function listStarWork(userId){
    return request({
        url: "/api/teaching/teachingWork/listStarWork?userId=" + userId + "&pageSize=" + 999,
        method: "get"
    })
}

/**
 * 获取精选作品
 */
export function getWorkGreat(pageNo, pageSize) {
    return request({
        url: "/api/teaching/teachingWork/choiceness?pageNo=" + pageNo + "&pageSize=" + pageSize,
        method: "get"
    })
}

/**
 * 劲作排行榜(本周作品,年度作品)
 * cycle 周期（上周: preWeek 周:week  年: year  全部：''）
 * orderBy 排序（评分:score  点赞:star  时间：time）
 */
export function getWorkRank(cycle, orderBy, pageNo, pageSize) {
    return request({
        url: "/api/teaching/teachingWork/leaderboard",
        method: "get",
        params: {
            cycle, orderBy, pageNo, pageSize
        }
    })
}

/**
 * 社区牛人
 * attention（粉丝数最多）
 * workNum (作品数量)
 * integral （积分）
 */
export function communityCattle(orderByType, pageNo, pageSize) {
    return request({
        url: "/api/teaching/teachingWork/communityCattle",
        method: "get",
        params:{orderByType, pageNo, pageSize}
    })
}

/**
 * 关注用户
 * @param {*} followedUserId 
 */
export function attentionUser(followedUserId) {
    return request({
        url: "/api/sys/user/attentionUser",
        method: "post",
        data: {
            followedUserId
        }
    })
}

/**
 * 是否关注
 * @param {}} workId 
 */
export function isAttentionUser(userId){
    return request({
        url: "/api/sys/user/isAttention?userId=" + userId,
        method: "get"
    })
}

/**
 * 关注的用户列表
 * @param {用户id}} userId 
 */
export function fllowUserList(userId) {
    return request({
        url: "/api/sys/user/listAttentionUser?userId="+userId + "&pageSize=999",
        method: "get"
    })
}

/**
 * 粉丝列表
 * @param {*} userId 
 */
export function fansList(userId) {
    return request({
        url: "/api/sys/user/listIdolUser?userId="+userId + "&pageSize=999",
        method: "get"
    })
}

/**
 * 作品评论/回复评论
 */
export function commentWork(workId, commentId, comment) {
    return request({
        url: "/api/teaching/teachingWork/saveComment",
        data: {
            workId: workId,
            commentId: commentId,
            comment: comment
        },
        method: "post"
    })
}

/**
 * 点赞评论
 */
export function starComment(commentId) {
    return request({
        url: "/api/teaching/teachingWork/starComment?commentId=" + commentId,
        method: "get"
    })
}
/**
 * 点赞作品
 */
export function starWork(workId) {
    return request({
        url: "/api/teaching/teachingWork/starWork?workId=" + workId,
        method: "get"
    })
}
/**
 * 收藏作品
 */
export function collectWork(workId) {
    return request({
        url: "/api/teaching/teachingWork/collectWork?workId=" + workId,
        method: "get"
    })
}

/**
 * 是否收藏了作品
 * @param {}} workId 
 */
export function isCollectWork(workId){
    return request({
        url: "/api/teaching/teachingWork/isCollectWork?workId=" + workId,
        method: "get"
    })
}

/**
 * 作品评分
 */
export function scoreWork(workId, score) {
    return request({
        url: "/api/teaching/teachingWork/scoreWork?workId=" + workId + "&score=" + score,
        method: "get"
    })
}


/**
 * 作品信息
 */
export function workInfo(workId) {
    return request({
        url: "/api/teaching/teachingWork/studentWorkInfo",
        method: "get",
        params: { workId }
    });
}

/**
 * 作品评论列表
 * @param {} workId 
 */
export function workComments(workId, page) {
    return request({
        url: "/api/teaching/teachingWork/queryTeachingWorkCommentByMainId?id=" + workId,
        method: "get",
        params: { workId, page }
    });
}

/**
* 获取用户信息
*/
export function getUserDetail(userId) {
    return request({
        url: "/api/teaching/user/detailById?userId=" + userId,
        method: "get"
    })
}

/**
* 删除作品
*/
export function deleteWork(id) {
    return request({
        url: "/api/teaching/teachingWork/delete",
        method: "delete",
        params: { id }
    });
}

/**
* 老师批改信息
*/
export function teacherWorkInfo(id) {
    return request({
        url: "/api/teaching/teachingWork/queryTeachingWorkCorrectByMainId",
        method: "get",
        params: { id }
    });
}

/**
* 社区在线时长
*/
export function communityOnline(second) {
    return request({
        url: "/api/teaching/teachingStudyLog/communityOnline",
        method: "get",
        params: { second }
    });
}


// WEBPACK FOOTER //
// ./src/api/community.js